<section class="content">
    <div class="card" style="padding: 25px">
        <div class="row">
            <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
              {{title}}<br>
              <span style="font-size: 15px;">PR2A report gives you the transactions seen in Axis Bank MIS was added to agent wallet account.
            </span>
            </div>
        </div>

        <div class="row">
            <div class="col-3">
                <mat-label>From Date</mat-label>
                <input type="date" [(ngModel)]="from_date"  (ngModelChange)="changeEvent()" class="main-border-class" />
            </div>
            <div class="col-3">
                <mat-label>To Date</mat-label>
                <input type="date" [(ngModel)]="to_date"  (ngModelChange)="changeEvent()" [min]="from_date" class="main-border-class" />
            </div>
            <div class="col-2">
              <mat-label>Customer Type</mat-label>
              <mat-select [(ngModel)]="selected_customer_type" class="main-border-class" (ngModelChange)="changeEvent()">
                <mat-option [value]="selected_customer_type" *ngFor="let selected_customer_type of customer_type_list">{{selected_customer_type}}</mat-option>
              </mat-select>
            </div>
            <div class="col-2">
                <button (click)="getClicked()"
                  style="font-size: 27px;margin-top: 10%;border-radius: 5px;background: blanchedalmond;"
                  [disabled]="from_date == null || to_date == null">Get</button>
            </div>

            <div *ngIf="!is_document_available" class="col-2">
                <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
                </mat-progress-spinner>
              </div>
            <div class="col-2" *ngIf="document_file!== null">
                <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top:25px"><i class="material-icons">
                    get_app
                  </i> Download Excel</button>
              </div>
        </div>
    </div>

  
</section>
